"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageAfterBulkAction = void 0;

var getPageAfterBulkAction = function getPageAfterBulkAction(pagination, isData) {
  if (pagination === undefined) {
    return 1;
  }

  if (isData) {
    return pagination.page;
  }

  return 1;
};

exports.getPageAfterBulkAction = getPageAfterBulkAction;